
// polyfills
import Es6Promise from 'es6-promise';
Es6Promise.polyfill();

import Vue from 'vue';

import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';

Sentry.init({
  dsn: process.env.VUE_APP_SENTRY,
  integrations: [new Integrations.Vue({Vue, attachProps: true})],
});

import App from './App.vue';

import Loading from 'vue-loading-overlay';
import VueI18n from 'vue-i18n';
import VTooltip from 'v-tooltip';
import VueObserveVisibility from 'vue-observe-visibility';
import VueGtm from 'vue-gtm';
import LoadScript from 'vue-plugin-load-script';

Vue.config.productionTip = false;

Vue.use(Loading);
Vue.use(VueI18n);
Vue.use(VTooltip);
Vue.use(VueObserveVisibility);
Vue.use(LoadScript);

// translations
import messages from './translations';

// store 
import store from "./store";

// router
import router from "./router";

let gtmContainer = process.env.VUE_APP_GTM_CONTAINER;

if(gtmContainer) {
  Vue.use(VueGtm, {
    id: process.env.VUE_APP_GTM_CONTAINER,
    enabled: true,
    debug: false,
    loadScript: false,
    vueRouter: router,
  });
}

const i18n = new VueI18n({
  locale: 'en',
  fallbackLocale: 'en',
  messages,
})

new Vue({
  store,
  router,
  i18n,
  render: h => h(App)
}).$mount('#booking')
